import {Modal} from '@forecast-it/design-system';

interface DeleteTicketModalProps {
	open: boolean;
	ticketSlug: string;
	loading: boolean;
	onConfirm: () => void;
	onCancel: () => void;
}

export function DeleteTicketModal({open, ticketSlug, loading, onConfirm, onCancel}: DeleteTicketModalProps) {
	if (!open) return null;

	return (
		<Modal onCloseModal={onCancel}>
			<Modal.Title>Delete ticket</Modal.Title>
			<Modal.Content>
				Are you sure you want to delete <strong>{ticketSlug}</strong>? This action cannot be undone.
			</Modal.Content>
			<Modal.Footer>
				<Modal.PrimaryFooterButton onPress={onConfirm} disabled={loading}>
					{loading ? 'Deleting…' : 'Delete'}
				</Modal.PrimaryFooterButton>
				<Modal.SecondaryFooterButton onPress={onCancel} disabled={loading}>
					Cancel
				</Modal.SecondaryFooterButton>
			</Modal.Footer>
		</Modal>
	);
}
